mutation StartEvent($eventId: ID!) {
  event: StreamToolsStartEvent(eventId: $eventId) {
    eventId
    status
    startedAt
  }
}
